import Vue from 'vue';

export default function (Vue) {
    let $utils = {
        format: 'jpg',
        getTranslationField($object, field, language = 'ro') {
            if (typeof $object.all_translations === "undefined" || typeof $object.all_translations[language] === "undefined") {
                return '';
            }
            return $object.all_translations[language][field];
        },
        getPlaceholder($params) {
            let width = $params.width ? $params.width : '';
            let height = $params.height ? $params.height : '';
            return '/media/placeholder' + '__w' + width + '_h' + height + ($params.bg ? '_b' . $size['bg'] : '') + '.' + this.format;
        },
        getImage(image, width, height, contain, bg, overlay) {
            return image;
            let image_url = image;
            if (typeof image === "object") {
                if(typeof image.file !== "undefined") {
                    image_url = image.file;
                } else {
                    image_url = null;
                }
            }
            if (!image_url) {
                return this.getPlaceholder({
                    width,
                    height,
                    bg,
                });
            }
            return this.computeImage({
                image_url,
                width,
                height,
                contain,
                bg,
                overlay,
            });
        },
        computeImage($params) {
            let width = $params.width ? $params.width : '';
            let height = $params.height ? $params.height : '';
            let contain = $params.contain ? $params.contain : false;
            let filename = $params.image_url.split('.');
            let ext = filename.pop();
            if (ext === 'svg') {
                return filename.join('.') + '.' + ext;
            }
            return filename.join('.') + '__w' + width + '_h' + height + (contain ? '_c' : '') + ($params.bg ? '_b' . $params.bg : '') + ($params.overlay ? '_o' . $params.overlay : '') + '.' + ext;
        },
    }

    Object.defineProperties(Vue.prototype, {
        $utils: {
            get: function () {
                return $utils;
            }
        },

    })
}
